module.exports = "<tr class=review-tab-service-inner> <td class=review-sku-name> </td> <td class=review-service-name> </td> <td class=\"review-quantity q-text-right\"> </td> <td class=\"review-estimated-cost q-text-right\"> </td> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ServicesTab/html/reviewServiceRowView.html
// module id = 1220
// module chunks = 1